import React from 'react';
import { PrimaryButton } from 'msteams-ui-components-react';
import { useThemeContext } from '../../../context/themeContext';
import { themedButtonText } from '../../../styles/SharedStyles';

export interface LoginButtonProps {
  onClick: (e?: any) => any;
  buttonText: string;
  disabled?: boolean;
}

export function LoginButton({
  onClick,
  buttonText,
  disabled,
}: LoginButtonProps): JSX.Element {
  const theme = useThemeContext();
  return (
    <div style={{ fontFamily: 'Segoe UI, Open Sans' }}>
      <PrimaryButton
        style={{
          display: 'block',
          margin: '5px auto 0px',
          padding: '17px 10px',
          width: 'auto',
          minWidth: '190px',
          lineHeight: 0.01,
          ...themedButtonText(theme),
        }}
        disabled={disabled}
        onClick={e => {
          !disabled && onClick(e);
        }}
      >
        {buttonText}
      </PrimaryButton>
      <span
        style={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          justifyContent: 'center',
          fontSize: 13,
        }}
      >
        <p>Don't have a profile?</p>
        <a
          style={{
            marginLeft: 4,
          }}
          target='_new'
          href='https://ims.bentley.com/'
        >
          Register
        </a>
      </span>
    </div>
  );
}
